module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/loans@2x-b13f81b4d813e89fa176c3eedfe2aee8.png";